import { Box, styled } from '@mui/material';
import SendImage from '~/assets/images/jsx/sendImage';
import { COLORS } from '~/data/ui/colors';
import theme from '~/theme';

export const BoxContactUsLeadBannerContainer = styled(Box)(
  ({ createLeadFinished }: { createLeadFinished: boolean }) => ({
    borderRadius: '8px',
    padding: '24px 16px',
    backgroundColor: createLeadFinished ? COLORS.white.main : COLORS.gray.light,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '12px',
    width: '100%',
    margin: 0,
    marginBottom: '30px',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
    },
  }),
);

export const ContentContainerBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  textAlign: 'center',
  gap: '24px',
  padding: '0 8px',
  [theme.breakpoints.up('md')]: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    height: '100%',
    textAlign: 'right',
    gap: '24px',
    padding: '0 18px',
  },
});

export const ImageContainerBoxMobile = styled(Box)({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  height: '100%',
  width: '100%',
  textAlign: 'right',
  padding: '12px 0',
  [theme.breakpoints.up('md')]: {
    display: 'none',
  },
});
export const SendImageDesktop = styled(SendImage)({
  display: 'none',
  [theme.breakpoints.up('md')]: {
    marginRight: '-35px',
  },
});
export const SendImageMobile = styled(SendImage)({
  display: 'block',
  [theme.breakpoints.up('md')]: {
    display: 'none',
  },
});
export const titleStyles = {
  fontSize: '22px',
  lineHeight: 'normal',
  // [theme.breakpoints.up('md')]: {
  //   fontSize: '30px',
  // },
};

export const subtitleStyles = {
  fontSize: '18px',
  lineHeight: 'normal',
  textAlign: 'center',
  maxWidth: '300px',
  [theme.breakpoints.up('md')]: {
    fontSize: '22px',
    textAlign: 'right',
  },
};

export const SendImageStylesMobile = {
  marginRight: '-16px',
};
export const SendImageStylesDesktop = {
  marginRight: '-39px',
};
